<!--
  컨텐츠 영역 포함된 전체 레이아웃..
-->
<script setup>
import CommonHeader from '@/components/common/CommonHeader.vue';
import DashboardAdBanner from "@/components/common/DashboardAdBanner.vue";
import CommonFooter from "@/components/common/CommonFooter.vue";
import { onMounted } from 'vue';

onMounted (() => {
  console.log("layoutContentsMain.vue ==============================================")
})

</script>
<template>

    <Common-header></Common-header>
    <router-view></router-view>

    <!-- 전 페이지 공통 : 광고 영역 + 푸터 -->
    <div class="container">
      <div class="inwrap">
        <DashboardAdBanner/>
      </div>
    </div>
    <CommonFooter/>

</template>
<style scoped>

</style>
